module.exports = __webpack_public_path__ + "static/img/cont59 (5).b49a74f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (5).jpg
// module id = xXde
// module chunks = 0